import { render, staticRenderFns } from "./SectionBasic.vue?vue&type=template&id=25b7133a&scoped=true&"
import script from "./SectionBasic.vue?vue&type=script&lang=js&"
export * from "./SectionBasic.vue?vue&type=script&lang=js&"
import style0 from "./SectionBasic.vue?vue&type=style&index=0&id=25b7133a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7133a",
  null
  
)

export default component.exports